import React, { useEffect } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { postMyrCreateTransaction } from "../redux/actions/postQrInitManual";
import { Navigate, useParams } from "react-router-dom";

const SpinWrapper = styled.div`
  background: white;
  padding: 20px 30px;
  border-radius: 12px;
  font-family: "HarmonyRegular";
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  /* .ant-spin-text {
    margin-top: 20px;
    width: 80%;
  } */
`;

const SpinerIndicatorWhiteBg = (props) => {
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 80, color: "#196ca0" }} spin />
  );
  return (
    <SpinWrapper>
      <div className="mb-5">{antIcon}</div>
      {props.thaiText ? (
        <>
          <p className="mb-0 text-center">{props.thaiText}</p>
          <p className="text-center">Please be patient while we redirect you</p>
        </>
      ) : (
        <p className="text-center">Please be patient while we redirect you</p>
      )}
    </SpinWrapper>
  );
};

export default SpinerIndicatorWhiteBg;
